import { ReservCell } from 'entities/Reservations';
import { Actions } from './actions';
import {
  CLEAR_ERROR_BOOKINGS,
  GET_CELL_SETTINGS_ERROR,
  GET_CELL_SETTINGS_REQUEST,
  GET_CELL_SETTINGS_SUCCESS,
  GET_LOCKED_CELL_ERROR,
  GET_LOCKED_CELL_REQUEST,
  GET_LOCKED_CELL_SUCCESS,
  GET_MANAGER_BOOKS_ERROR,
  GET_MANAGER_BOOKS_REQUEST,
  GET_MANAGER_BOOKS_SUCCESS,
  POST_BOOK_ERROR,
  POST_BOOK_REQUEST,
  POST_BOOK_SUCCESS,
  POST_CELL_ERROR,
  POST_CELL_REQUEST,
  POST_CELL_SUCCESS,
  PUT_BLOCK_ALL_ERROR,
  PUT_BLOCK_ALL_REQUEST,
  PUT_BLOCK_ALL_SUCCESS,
  PUT_BLOCK_ERROR,
  PUT_BLOCK_REQUEST,
  PUT_BLOCK_SUCCESS,
  PUT_BOOK_ERROR,
  PUT_BOOK_REQUEST,
  PUT_BOOK_SUCCESS,
  PUT_EDIT_BOOK_ERROR,
  PUT_EDIT_BOOK_REQUEST,
  PUT_EDIT_BOOK_SUCCESS,
} from './constants';

const initialState = {
  books: null as ReservCell[] | null,
  unconfirmedBook: 0 as number,
  fromDate: null as null | Date,
  toDate: null as null | Date,
  loading: false as boolean,
  error: null as Error | null,
  cellSettingsError: null as Error | null,
  lockedCellError: null as Error | null,
  managerBooksError: null as Error | null,
  cellSetting: {},
  lockedCell: null as any,
  headerLoader: false as boolean,
};

type ReservationsState = typeof initialState;

export const reservationsReducer = (state: ReservationsState = initialState, action: Actions) => {
  switch (action.type) {
    case PUT_BOOK_REQUEST:
    case PUT_BLOCK_REQUEST:
    case PUT_BLOCK_ALL_REQUEST:
    case PUT_EDIT_BOOK_REQUEST:
    case POST_CELL_REQUEST:
    case POST_BOOK_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_MANAGER_BOOKS_REQUEST: {
      return {
        ...state,
        managerBooksError: null,
        fromDate: action.params.from,
        toDate: action.params.to,
      };
    }
    case GET_MANAGER_BOOKS_SUCCESS: {
      return {
        ...state,
        loading: false,
        managerBooksError: null,
        books: action.payload,
        unconfirmedBook: action.unconfirmedBook,
      };
    }
    case GET_MANAGER_BOOKS_ERROR: {
      return {
        ...state,
        loading: false,
        managerBooksError: action.payload,
      };
    }
    case PUT_BLOCK_ALL_ERROR:
    case PUT_BLOCK_ERROR:
    case PUT_BOOK_ERROR:
    case PUT_EDIT_BOOK_ERROR:
    case POST_CELL_ERROR:
    case POST_BOOK_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CLEAR_ERROR_BOOKINGS:
    case POST_CELL_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case PUT_BLOCK_ALL_SUCCESS:
    case PUT_BLOCK_SUCCESS:
    case PUT_BOOK_SUCCESS:
    case PUT_EDIT_BOOK_SUCCESS:
    case POST_BOOK_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        books: null,
        unconfirmedBook: 0,
      };
    }
    case GET_CELL_SETTINGS_SUCCESS: {
      return {
        ...state,
        cellSetting: action.payload,
        headerLoader: false,
        cellSettingsError: null,
      };
    }
    case GET_CELL_SETTINGS_ERROR: {
      return {
        ...state,
        cellSettingsError: action.payload,
        headerLoader: false,
      };
    }
    case GET_CELL_SETTINGS_REQUEST:
    case GET_LOCKED_CELL_REQUEST: {
      return {
        ...state,
        headerLoader: true,
        cellSettingsError: null,
      };
    }
    case GET_LOCKED_CELL_SUCCESS: {
      return {
        ...state,
        lockedCell: action.payload,
        loading: false,
        headerLoader: false,
      };
    }
    case GET_LOCKED_CELL_ERROR: {
      return {
        ...state,
        lockedCellError: action.payload,
        loading: false,
        headerLoader: false,
      };
    }
    default: {
      return state;
    }
  }
};
